import type { AppDefinition } from '../types';

/**
 * Bring-your-own integration — the catch-all card.
 *
 * Exists so an Org whose system is not in the catalog has somewhere to raise
 * its hand, which is how the next connector gets prioritized.
 */
export const CUSTOM_APP: AppDefinition = {
  id: 'custom-app',
  nameKey: 'apps.custom-app.name',
  descriptionKey: 'apps.custom-app.description',
  logo: '/images/apps/custom-app-logo.svg',
  categories: ['custom'],
  status: 'soon',
  label: 'soon',
};
